export interface oddsUpdateItem {
  NodeId: string;
  Odd: number;
  Locked: boolean;
  NotAvailable: boolean;
}
